<template>
  <div class="files scrollbar">
    <div
      role="button"
      class="files-item"
      v-for="item in currentStore"
      :key="item.id"
      @click="handlePreview(item)">
      <template v-if="item.type == 'video'">
        <video
            class="files-item__img"
            :src="getSrc(item)"
            :alt="item.name">
        </video>
        <span class="files-item__play"></span>
      </template>
      <template v-else>
        <img
          src="/images/blank.png"
          class="files-item__img lazy-load"
          :data-src="getSrc(item)"
          :alt="item.name"
        >
        <span class="files-item__loading">
          <Icon  path="loading" name="spinner" type="grey" />
        </span>
      </template>
    </div>
    <div ref="loadmore" class="loadmore" data-name="keep it"></div>
  </div>
</template>

<script>
import 'intersection-observer'
import { mapGetters } from 'vuex'
import Icon from '@/components/icon'
import { lazyLoadImages } from '@/utils/lazyload'

export default {
  name: 'FileList',
  components: {
    Icon
  },
  computed: {
    ...mapGetters([
      'hasNextPage',
      'currentStore'
    ])
  },
  watch: {
    currentStore() {
      this.$nextTick(lazyLoadImages)
    }
  },
  mounted() {
    this.init()
    lazyLoadImages()
  },
  methods: {
    init() {
      const threshold = 0.2
      const observer = new IntersectionObserver(changes => {
        changes.forEach(({ intersectionRatio }) => {
          if (intersectionRatio > threshold) {
            this.handlePullingUp()
          }
        })
      }, { threshold: [ threshold ] })

      observer.observe(this.$refs.loadmore)
    },
    getSrc(file) {
      const { shareId } = this.$route.params

      return `/na-api/shares/${shareId}/files/${file.id}/preview/`
    },
    handlePreview(file) {
      this.$router.push({
        name: 'shares',
        params: {
          filename: file.name
        }
      })
      this.$store.commit('INIT_PREVIEW', file)
    },
    handlePullingUp() {
      if (this.hasNextPage) {
        const { shareId } = this.$route.params
        this.$store.dispatch('GET_FILES_BY_SHAREID', shareId)
      }
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');
  .files {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    flex-basis: 1px;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    padding: 32px 44px 16px;
    overflow-x: hidden;
    & &-item {
      position: relative;
      flex: 0 0 344px;
      height: 344px;
      margin: 0 12px 12px 0;
      border-radius: 8px;
      border: 1px solid var(--border-color, @grey-200);
      background-color: @grey-700;
      transition: all linear .2s;
      overflow: hidden;
      cursor: pointer;
      &.is-loaded {
        background-color: var(--background-color, @white);
        .files-item__loading {
          display: none;
        }
      }
      &:hover {
        border-color: var(--border-color, @grey-300);
      }
      &__img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: all linear .2s;
        &:hover {
          transform: scale(1.1);
        }
      }
      &__loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        font-size: 24px;
      }
      &__play {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 52px;
        height: 52px;
        margin: -26px 0 0 -26px;
        background: url(../../assets/play.png) no-repeat;
        z-index: 1;
        cursor: pointer;
      }
    }
    .loadmore {
      height: 1px;
      background-color: transparent;
    }
  }

  @media screen and (max-width: 1376px) {
    .files {
      padding: 16px;
      & &-item {
        flex: 0 0 32%;
        margin-right: 1%;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .files {
      & &-item {
        flex: 0 0 49.5%;
        margin-right: 1%;
        &:nth-child(2n) {
          margin-right: 0;
        }
        &:nth-child(3n) {
          margin-right: 1%;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .files {
      padding: 8px;
      & &-item {
        flex: 0 0 100%;
        &:nth-child(n) {
          margin-right: 0;
        }
      }
    }
  }
</style>
